import styled, { css } from 'styled-components';
import { inputStyle, invalidStyling } from './inputStyles';

const TextInput = styled.input`
  ${inputStyle};
  min-height: 32px;

  // remove arrow from number input
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  // remove arrow from number input
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ${({ wasValidated }) =>
    // Only show invalid styles after the input has been validated
    wasValidated &&
    css`
      &:invalid {
        ${invalidStyling};
      }
    `};
`;

export default TextInput;
